import { ResourceCode } from '@/const/code';

export default [
  {
    path: '/payments/returnUrl',
    name: 'paymentReturnUrl',
    component: () => import('@/views/payment/PaymentReturn.vue'),
    meta: {
      resource: ResourceCode.PAYMENT_RETURN_URL,
      layout: 'full',
    },
  },
]
